import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ThemeService } from './core/services/theme.service';
import { ToastContainerComponent } from './shared/components/toast-container/toast-container.component';
import { PopupContainerComponent } from './shared/components/popup/popup-container/popup-container.component';
import { ApplicationStore, ApplicationStoreType } from './core/store/application.store';

@Component({
    selector: 'juyo-root',
    imports: [RouterOutlet, ToastContainerComponent, PopupContainerComponent],
    styleUrl: './app.scss',
    template: `
        <juyo-toast-container class="toasts"></juyo-toast-container>
        <juyo-popup-container></juyo-popup-container>
        <router-outlet />
    `,
})
export class App {
    // load theme, do not remove
    private readonly theme = inject(ThemeService);

    protected applicationStore: ApplicationStoreType = inject(ApplicationStore);

    constructor() {
    }
}
